import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FieldWrapper, FormlyModule } from '@ngx-formly/core';

@Component({
  selector: 'app-formly-row-wrapper',
  template: `
    <div class="d-flex align-items-center gap-3">
      <formly-field *ngFor="let f of field.fieldGroup" [field]="f">
      </formly-field>
    </div>
  `,
  standalone: true,
  imports: [FormlyModule, CommonModule],
})
export class RowFormlyWrapperComponent extends FieldWrapper {}
